import { render } from "./print.vue?vue&type=template&id=ef63eff8&scoped=true"
import script from "./print.vue?vue&type=script&lang=js"
export * from "./print.vue?vue&type=script&lang=js"

import "./print.vue?vue&type=style&index=0&id=ef63eff8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef63eff8"]])

export default __exports__